import ExcelJS from 'exceljs';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import CustomTable from '../../components/Table';
import SettlementController, {
  KnockStoreSettleDetailType,
  KnockStoreSettleType,
} from '../../controller/SettlementController';
import { useNavigate } from 'react-router-dom';

const KnockStoreSettle = () => {
  const navigate = useNavigate();
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [month, setMonth] = useState<number>(new Date().getMonth() + 1);

  const [visibleMonthSelect, setVisibleMonthSelect] = useState<boolean>(false);
  const [salesList, setSalesList] = useState<KnockStoreSettleType[]>([]);
  const [selectedList, setSelectedList] = useState<KnockStoreSettleType>();

  const selectRef = useRef<HTMLDivElement>(null);

  // API 호출
  const getStoreSettlement = async () => {
    try {
      const oData = {
        start_year: year,
        start_month: month,
        end_year: year,
        end_month: month,
      };

      const response = await SettlementController.getKnockStoreSettlement(oData);

      if (response && response.data) {
        console.log('getKnockStoreSettlement', response.data);
        if (response.data.ok) {
          setSelectedList({
            key: `${year}-${month > 9 ? month : `0${month}`}`,
            data: response.data.data.period,
          });
          setSalesList(response.data.data.week);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const numberToUpper = (value: number) => {
    return String.fromCharCode(value + 65);
  };

  const excelDownloadClick = (van: string) => {
    if (selectedList) {
      let payselectedList: KnockStoreSettleType = selectedList;

      if (van === 'all') {
        payselectedList = {
          key: selectedList.key,
          data: selectedList.data,
        };
      } else if (van === 'kovan') {
        const data = selectedList.data.filter((v) => v.pay_company === 'KOVAN');
        payselectedList = {
          key: selectedList.key,
          data: data,
        };
      } else if (van === 'nice') {
        const data = selectedList.data.filter((v) => v.pay_company === 'NICE');
        payselectedList = {
          key: selectedList.key,
          data: data,
        };
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sheet 1');
      const totalScheduledSettlementAmt = payselectedList.data.reduce(
        (total: number, data: KnockStoreSettleDetailType) => {
          return total + Number(data.scheduled_settlement_amt);
        },
        0,
      );

      worksheet.mergeCells('A1:K1');
      worksheet.getCell('A1').value = '노크노크 매장 정산 내역';
      worksheet.mergeCells('A2:K2');
      worksheet.getCell('A2').value = '거래기간 : ' + payselectedList.key;

      // const uploadedHeader = excelHeader;
      const uploadedHeader = [...excelHeader.slice(0, 7), '', ...excelHeader.slice(7)];

      // console.log('uploadedHeader', uploadedHeader);

      const mainHeader = worksheet.addRow(uploadedHeader.slice(0, uploadedHeader.length));

      // worksheet.addRow(excelSubHeader.slice(0, excelSubHeader.length)););
      mainHeader.eachCell((cell: any) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });
      worksheet.getCell('H3').value = undefined;
      worksheet.mergeCells('G3:H3');
      worksheet.getCell('G4').value = '매장부담(B1)';
      worksheet.getCell('H4').value = '노크노크부담(B2)';

      uploadedHeader.map((cell: any, index: number) => {
        if (index !== 6 && index !== 7) {
          worksheet.mergeCells(`${numberToUpper(index)}3:${numberToUpper(index)}4`);
        }
      });

      // for (let i = 3; i <= 13; i++) {
      //   worksheet.getColumn(i).numFmt = '#,##0';
      // }
      for (let i = 0; i < payselectedList.data.length; i++) {
        worksheet.addRow([
          Number(payselectedList.data[i].order_count),
          Number(payselectedList.data[i].cancel_order_count.toLocaleString()),
          payselectedList.data[i].parent_store_name,
          payselectedList.data[i].store_name,
          payselectedList.data[i].pay_company,
          Number(payselectedList.data[i].order_amount),
          Number(payselectedList.data[i].store_discount_amt),
          Number(payselectedList.data[i].com_discount_amt),
          Number(payselectedList.data[i].delivery_price),
          Number(payselectedList.data[i].room_tip),
          Number(payselectedList.data[i].final_payment_amt),
          Number(payselectedList.data[i].payment_fee),
          Number(payselectedList.data[i].relay_fee),
          Number(payselectedList.data[i].vat),
          Number(payselectedList.data[i].total_deductions),
          Number(payselectedList.data[i].order_settlement_amt),
          Number(payselectedList.data[i].cancel_amt),
          Number(payselectedList.data[i].carried_balance),
          Number(payselectedList.data[i].scheduled_settlement_amt),
          Number(payselectedList.data[i].minus_balance),
          payselectedList.data[i].bank_name,
          payselectedList.data[i].account_nm,
          payselectedList.data[i].account_holder,
          payselectedList.data[i].email,
          payselectedList.data[i].business_number,
        ]);
      }

      // 아래 총합계
      const lastRowIndex = payselectedList.data.length + 5;
      worksheet.mergeCells('A' + lastRowIndex + ':K' + lastRowIndex);
      worksheet.getCell('A' + lastRowIndex).value =
        '총 최종 정산 금액: ' + totalScheduledSettlementAmt.toLocaleString() + '원';

      // 엑셀 파일로 저장
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `노크노크 정산 상세내역_${payselectedList.key}_${
            van === 'all' ? '전체' : van === 'kovan' ? 'KOVAN' : van === 'nice' ? 'NICE' : ''
          }.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
      });
    }
  };

  useEffect(() => {
    getStoreSettlement();

    const handleClickOutside = (event: any) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setVisibleMonthSelect(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (salesList.length > 0) {
      console.log('salesList', salesList);
    }
  }, [salesList]);

  //테이블 헤더
  const excelHeader = [
    '주문건수',
    '정산차감 주문건수',
    '호텔명',
    '매장명',
    '결제사',
    '주문금액(A)',
    '할인금액(B)',
    '배달팁(C)',
    '객실관리팁(D)',
    '최종결제금액(E)',
    '결제수수료(F)',
    '중개수수료(G)',
    '부가세(H)',
    '공제총액(I)',
    '정산 예정 금액(J)',
    '취소 정산 금액(K)',
    '전 정산의 미차감액(L)',
    '최종 정산 금액(M)',
    '미차감액(N)',
    '은행',
    '계좌번호',
    '성명',
    '대표자 이메일',
    '사업자번호',
  ];
  const excelSubHeader = ['매장부담(B1)', '노크노크부담(B2)'];

  const RenderMonthSelect = () => {
    const arrayItems = Array.from({ length: 12 }, (_, index) => index + 1);
    return (
      <div className={`selectBox ${!visibleMonthSelect && 'none'}`} ref={selectRef}>
        <div className="yearSelect">
          <button className="left" onClick={() => setYear(year - 1)} />
          {year}
          <button className="right" onClick={() => setYear(year + 1)} />
        </div>
        <div className="monthSelect">
          {arrayItems.map((item, index) => (
            <div
              key={index}
              className={`monthItem ${month === item && 'active'}`}
              onClick={() => setMonth(item)}>
              {item}월
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderLogic = () => {
    return (
      <table
        style={{
          border: '1px solid black',
          borderCollapse: 'collapse',
          width: '40%', // 표 너비를 50%로 설정
          textAlign: 'center',
          // margin: 'auto', // 가운데 정렬을 위한 자동 여백
        }}>
        <thead>
          <tr style={{ backgroundColor: '#f2f2f2' }}>
            <th colSpan={2} style={{ border: '1px solid black', padding: '4px' }}>
              설명
            </th>
            <th style={{ border: '1px solid black', padding: '4px' }}>수식</th>
            <th style={{ border: '1px solid black', padding: '4px' }}>비고</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>A</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>주문금액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td rowSpan={2} style={{ border: '1px solid black', padding: '4px' }}>
              B
            </td>
            <td style={{ border: '1px solid black', padding: '4px' }}>B1: 매장부담할인</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>B2: 노크노크부담할인</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>C</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>배달팁</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>D</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>객실관리팀</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>E</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>최종결제금액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>A - B + C + D</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>F</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>결제수수료</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>(E - D) * 0.03</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>
              F 소수점 버림 , 해외결제 수수료 0.04
            </td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>G</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>중개수수료</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>(E + B2 - C - D) * 0.068</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>G 소수점 버림</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>H</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>부가세</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>(F * 0.1) + (G * 0.1)</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>H 소수점 버림</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>I</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>공제총액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>F + G + H</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>J</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>정산 예정 금액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>E - D + B2 - I</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>K</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>취소 정산 금액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>L</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>전 정산의 미차감액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}>가장 최근 정산의 (N)</td>
          </tr>
          <tr style={{ backgroundColor: 'yellow' }}>
            <td style={{ border: '1px solid black', padding: '4px' }}>M</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>최종 정산 금액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>J - (K + L)</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>{`J < K + L 인 경우 0`}</td>
          </tr>
          <tr style={{ backgroundColor: 'rgb(255, 200, 200)' }}>
            <td style={{ border: '1px solid black', padding: '4px' }}>N</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>미차감액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>(K + L) - J</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>{`K + L < J 인 경우 0`}</td>
          </tr>
        </tbody>
      </table>
    );
  };

  const renderTableItem = () => {
    return (
      <>
        {selectedList &&
          selectedList.data.map((data: KnockStoreSettleDetailType, dataIndex: number) => (
            <tr className="webTableWrap">
              <td>
                {data.order_count === null ? 'null' : Number(data.order_count.toLocaleString())}
              </td>
              <td>
                {data.order_count === null
                  ? 'null'
                  : Number(data.cancel_order_count.toLocaleString())}
              </td>
              <td>{data.parent_store_name}</td>
              <td>{data.store_name}</td>
              <td>{data.pay_company}</td>
              <td>₩{Number(data.order_amount).toLocaleString()}</td>
              <td>₩{Number(data.store_discount_amt).toLocaleString()}</td>
              <td>₩{Number(data.com_discount_amt).toLocaleString()}</td>
              <td>₩{Number(data.delivery_price).toLocaleString()}</td>
              <td>₩{Number(data.room_tip).toLocaleString()}</td>
              <td>₩{Number(data.final_payment_amt).toLocaleString()}</td>
              <td>₩{Number(data.payment_fee).toLocaleString()}</td>
              <td>₩{Number(data.relay_fee).toLocaleString()}</td>
              <td>₩{Number(data.vat).toLocaleString()}</td>
              <td>₩{Number(data.total_deductions).toLocaleString()}</td>
              <td>₩{Number(data.order_settlement_amt).toLocaleString()}</td>

              <td>₩{Number(data.cancel_amt).toLocaleString()}</td>
              <td>₩{Number(data.carried_balance).toLocaleString()}</td>
              <td style={{ backgroundColor: 'yellow' }}>
                ₩{Number(data.scheduled_settlement_amt).toLocaleString()}
              </td>
              <td style={{ backgroundColor: 'rgb(255, 200, 200)' }}>
                ₩{Number(data.minus_balance).toLocaleString()}
              </td>

              <td>{data.bank_name}</td>
              <td>{data.account_nm}</td>
              <td>{data.account_holder}</td>
              <td>{data.email}</td>
              <td>{data.business_number}</td>
            </tr>
          ))}
      </>
    );
  };

  return (
    <Style>
      <div className="rightContentWrap">
        <button className="backButton" onClick={()=>navigate('/dashboard')}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
        </button>
        <h1>KNOCKKNOCK 매장 정산</h1>
        <div className="listWrap">
          {/* <img
            src={`https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock.ivid.kr/settlelogic.png`}
            alt="calendar"
          /> */}
          {renderLogic()}
        </div>
        <div className="listWrap">
          <div className="listItem" onClick={() => setVisibleMonthSelect(true)}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`} alt="calendar" />
            <h4>
              {year}년 {month}월
            </h4>
          </div>
          <button onClick={getStoreSettlement}>
            <h4>조회</h4>
          </button>
          {visibleMonthSelect && <RenderMonthSelect />}

          <div className=""></div>
        </div>
        <div className="listWrap">
          {salesList.map((item, index) => (
            <div key={index} className="listItem week" onClick={() => setSelectedList(item)}>
              <h4>{item.key}</h4>
            </div>
          ))}
          <button
            onClick={() => {
              excelDownloadClick('all');
            }}>
            <h4>전체 액셀 저장</h4>
          </button>
          <button
            onClick={() => {
              excelDownloadClick('nice');
            }}>
            <h4>NICE 액셀 저장</h4>
          </button>
          <button
            onClick={() => {
              excelDownloadClick('kovan');
            }}>
            <h4>KOVAN 액셀 저장</h4>
          </button>
        </div>
        <CustomTable
          tableHeader={excelHeader}
          subHeader={excelSubHeader}
          renderTableItem={renderTableItem}
          type="border"
        />
      </div>
    </Style>
  );
};

export default KnockStoreSettle;

const Style = styled.div`
  .rightContentWrap {
    width: 100%;
    height: 100vh;
    background: #ffffff;
    padding: 2% 4%;
  }

  .listWrap {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    margin: 10px 0;
    position: relative;

    .listItem {
      min-width: 160px;
    }

    .selectBox {
      width: 240px;
      top: 46px;
      position: absolute;
      background: #ffffff;
      border-radius: 5px;
      z-index: 1;

      .yearSelect {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 6px 8px;
        border-radius: 5px 5px 0 0;
        border: 1px solid #dedede;
        border-bottom: none;
        button {
          padding: 0;
          background: none;
        }
        button.left {
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          border-right: 12px solid #333333;
        }
        button.right {
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          border-left: 12px solid #333333;
        }
      }
      .monthSelect {
        display: flex;
        flex-wrap: wrap;
        border-top: none;
        .monthItem {
          width: 80px;
          padding: 4px;
          border: 1px solid #dedede;
          text-align: center;
          cursor: pointer;
        }
        .monthItem.active {
          background: #4dd2ae;
          color: #ffffff;
        }
        .monthItem:nth-child(10) {
          border-radius: 0 0 0 5px;
        }
        .monthItem:nth-child(12) {
          border-radius: 0 0 5px 0;
        }
      }
    }

    .selectBox:before {
      content: '';
      position: absolute;
      left: 20px;
      top: -9px;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 10px solid #dedede;
    }
    .selectBox:after {
      content: '';
      position: absolute;
      left: 21px;
      top: -7px;
      width: 0;
      height: 0;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 8px solid #ffffff;
    }

    .listItem {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 6px 16px;
      border: 2px solid #cecece;
      border-radius: 5px;
      cursor: pointer;
      h4 {
        color: #333333;
        font-weight: 500;
      }
    }
    .listItem:hover {
      border-color: #40977f;
    }
    .listItem.week:hover {
      h4 {
        color: #40977f;
      }
    }
    button {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 8px 20px;
      border-radius: 5px;
      border: none;
      background: #40977f;
      h4 {
        font-weight: 600;
        color: #ffffff;
      }
    }
    button:hover {
      background: #4dd2ae;
    }
  }

  /* table */
  .normalTable thead tr {
    font-size: 14px;
    white-space: nowrap;
  }
  .normalTable tbody td {
    font-size: 14px;
    padding: 8px 10px;
    font-weight: 500;
    white-space: nowrap;

    img {
      width: 16px;
      cursor: pointer;
    }
  }
`;
